import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-blue-100 flex items-center justify-center px-4">
      <Helmet>
        <title>Page introuvable — To The Road</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="text-center max-w-lg">
        <div className="text-8xl md:text-9xl font-bold text-blue-500 mb-4 font-quicksand">404</div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 font-quicksand">
          Page introuvable
        </h1>
        <p className="text-lg text-gray-600 mb-10">
          Cette page n'existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          className="inline-block bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 shadow-md hover:shadow-xl"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
